<template>
    <div>
        <button type="button" @click="showModal = true" :class="'button--tertiary' + modifier">
            <slot></slot>
        </button>

        <DeleteModal v-if="showModal" @confirm="confirm" @close="showModal = false" />
    </div>
</template>

<script setup>
import { ref } from 'vue'
import axios from 'axios'
import DeleteModal from './DeleteModal.vue'

const props = defineProps({
    action: {
        type: String,
        required: true,
    },
    modifier: {
        type: String,
        required: false,
        default: '',
    },
})

const showModal = ref(false)

const confirm = async () => {
    try {
        const { data } = await axios.delete(props.action)
        window.location = data.redirect
    } catch (err) {
        console.error(err)
    }
}
</script>

<style></style>
